import { Button } from '@gearbelt/ui/components';
import { Link } from 'react-router-dom';

import magnifyingGlass from '@/assets/signup/magnifying-glass.svg';
import { env } from '@/environment';
import { SignUpSteps, useSignUpStore } from '@/stores/signup.store';

export const UsedEmailStep = () => {
  const {
    signUpStep,
    signUpForm: { email },
  } = useSignUpStore();
  const encodedEmail = encodeURIComponent(email);

  const forgotPasswordRedirectUrl = `${env.fusionAuth.authority}/password/forgot?email=${encodedEmail}&client_id=${env.fusionAuth.clientId}`;

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-4">
        <img src={magnifyingGlass} alt="magnifying glass" />
        <h2 className="text-center text-xl font-bold">
          {signUpStep === SignUpSteps.UsedGearbeltEmail ? 'This email is already in use' : 'Log in to create your Gearbelt workspace'}
        </h2>
        <div className="text-default-text text-center text-sm">
          We found an existing account with the email <span className="font-bold">{email}</span>.
        </div>
        <div className="text-default-text text-center text-sm">
          {signUpStep === SignUpSteps.UsedGearbeltEmail
            ? 'Please log back into Gearbelt. If you were recently invited, please check your inbox for an invitation link.'
            : 'Please log in to create your Gearbelt workspace. If you were recently invited, please check your inbox for an invitation link.'}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Link to="/login">
          <Button size="lg" className="mt-3 w-full py-4 text-base" type="button">
            Login
          </Button>
        </Link>

        <a href={forgotPasswordRedirectUrl}>
          <Button variant="grey" size="lg" className="w-full py-2 text-base" type="button">
            I forgot my password
          </Button>
        </a>
      </div>
    </>
  );
};
